const EmptyDeclineAppSvg = () => {
    return (
        <svg width="150" height="150" viewBox="0 0 150 150" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_24243_46011)">
                <path
                    d="M9.125 43.625H127.625V131.375C127.625 134.689 124.939 137.375 121.625 137.375H15.125C11.8113 137.375 9.125 134.689 9.125 131.375V43.625Z"
                    fill="#EFF3F9"
                />
                <path
                    d="M127.75 101.375V121.625C127.75 123.844 127.281 125.969 126.468 127.875C124.031 133.375 118.531 137.25 112.125 137.25H24.6247C4.87476 141 8.99966 130.25 8.99966 121.625V43.5H18.3747V121.625C18.3747 125.063 21.1872 127.875 24.6247 127.875H84.1872C84.0622 126.844 83.9997 125.813 83.9997 124.75C83.9997 117.291 86.9628 110.137 92.2373 104.863C97.5117 99.5882 104.665 96.625 112.125 96.625C117.906 96.625 123.281 98.375 127.75 101.375Z"
                    fill="#CFE0F3"
                />
                <rect x="25.5" y="60.75" width="18.75" height="18.75" rx="3" fill="#B6CAE5" />
                <rect x="59.25" y="60.75" width="18.75" height="18.75" rx="3" fill="#B6CAE5" />
                <rect x="93" y="60.75" width="18.75" height="18.75" rx="3" fill="#B6CAE5" />
                <rect x="25.5" y="94.5" width="18.75" height="18.75" rx="3" fill="#B6CAE5" />
                <rect x="59.25" y="94.5" width="18.75" height="18.75" rx="3" fill="#B6CAE5" />
                <rect x="93" y="94.5" width="18.75" height="18.75" rx="3" fill="#B6CAE5" />
            </g>
            <g clip-path="url(#clip1_24243_46011)">
                <path d="M9 21.75C9 18.4363 11.6863 15.75 15 15.75H121.748C125.061 15.75 127.747 18.4363 127.747 21.75V43.875H9V21.75Z" fill="#EF272E" />
                <path
                    d="M21.375 15.7488C17.231 15.7488 13.4302 13.1938 10.4999 16.1241C7.56966 19.0543 9.14413 27.3552 9.14413 31.4992V43.9992H18.5191V28.3742C18.5191 23.2398 17.5531 18.5957 21.375 15.7488Z"
                    fill="#D61920"
                />
            </g>
            <g clip-path="url(#clip2_24243_46011)">
                <path
                    d="M139.75 125.25C139.75 126.333 139.75 127.261 139.596 128.344L139.132 131.128C137.894 136.388 134.955 140.873 130.933 144.277C130.779 144.431 130.469 144.586 130.315 144.741C128.922 145.823 127.375 146.752 125.674 147.525L124.746 147.989C123.354 148.608 122.116 149.072 120.569 149.381C119.796 149.536 119.177 149.691 118.404 149.845C117.166 150 116.083 150 115 150C101.388 150 90.2505 138.862 90.2505 125.25C90.2505 111.637 101.388 100.5 115 100.5C128.613 100.5 139.75 111.637 139.75 125.25Z"
                    fill="#EF272E"
                />
                <path
                    d="M125.674 132.212C126.602 133.14 126.602 134.687 125.674 135.77C125.21 136.234 124.591 136.543 123.972 136.543C123.354 136.543 122.735 136.234 122.271 135.77L115 128.654L107.885 135.77C107.421 136.234 106.802 136.543 106.183 136.543C105.565 136.543 104.946 136.234 104.482 135.77C103.554 134.841 103.554 133.295 104.482 132.212L111.597 125.096L104.482 117.98C103.554 117.052 103.554 115.505 104.482 114.423C105.41 113.495 106.957 113.495 108.04 114.423L115.155 121.538L122.116 114.423C123.044 113.495 124.591 113.495 125.674 114.423C126.602 115.351 126.602 116.898 125.674 117.98L118.558 125.096L125.674 132.212Z"
                    fill="white"
                />
            </g>
            <path
                d="M46.25 12.25C46.25 8.79822 43.4518 6 40 6C36.5482 6 33.75 8.79822 33.75 12.25V21.625C33.75 25.0768 36.5482 27.875 40 27.875C43.4518 27.875 46.25 25.0768 46.25 21.625V12.25Z"
                fill="#CFE0F3"
            />
            <path
                d="M102.5 12.25C102.5 8.79822 99.7018 6 96.25 6C92.7982 6 90 8.79822 90 12.25V21.625C90 25.0768 92.7982 27.875 96.25 27.875C99.7018 27.875 102.5 25.0768 102.5 21.625V12.25Z"
                fill="#CFE0F3"
            />
            <path
                d="M39.999 6V15.375C39.999 17.0326 40.6575 18.6223 41.8296 19.7944C43.0017 20.9665 44.5914 21.625 46.249 21.625V12.25C46.249 10.5924 45.5905 9.00268 44.4184 7.83058C43.2463 6.65848 41.6566 6 39.999 6ZM96.249 6V15.375C96.249 17.0326 96.9075 18.6223 98.0796 19.7944C99.2517 20.9665 100.841 21.625 102.499 21.625V12.25C102.499 10.5924 101.841 9.00268 100.668 7.83058C99.4963 6.65848 97.9066 6 96.249 6Z"
                fill="#EFF3F9"
            />
            <defs>
                <clipPath id="clip0_24243_46011">
                    <rect width="118.75" height="93.75" fill="white" transform="translate(9 43.625)" />
                </clipPath>
                <clipPath id="clip1_24243_46011">
                    <path d="M9 21.75C9 18.4363 11.6863 15.75 15 15.75H121.748C125.061 15.75 127.747 18.4363 127.747 21.75V43.875H9V21.75Z" fill="white" />
                </clipPath>
                <clipPath id="clip2_24243_46011">
                    <rect width="49.5" height="49.5" fill="white" transform="translate(90.2505 100.5)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default EmptyDeclineAppSvg;
